import { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';

import { OnboardingProvider } from '../contexts/OnboardingContext';
import MinimalLayout from '../layouts/MinimalLayout';
import MinimalSideLayout from '../layouts/MinimalSideLayout';
import Loadable from './Loadable';
import PublicRoute from './PublicRoute';

// Lazy Imports
const LoginPage = Loadable(
  lazy(() => import('../pages/onboardingPages/LoginPage')),
);
const LoginMfaPage = Loadable(
  lazy(() => import('../pages/onboardingPages/LoginMfaPage')),
);
const NotFoundPage = Loadable(lazy(() => import('../pages/NotFoundPage')));

// Route Object
const AuthenticationRoutes: RouteObject = {
  path: '/auth',
  element: (
    <PublicRoute>
      <OnboardingProvider>
        <Outlet />
      </OnboardingProvider>
    </PublicRoute>
  ),
  children: [
    {
      element: <MinimalSideLayout />,
      children: [
        {
          index: true,
          element: <LoginPage />,
        },
        {
          path: '*',
          element: <NotFoundPage />,
        },
      ],
    },
    {
      element: <MinimalLayout />,
      children: [
        {
          path: 'mfa',
          element: <LoginMfaPage />,
        },
      ],
    },
  ],
};

export default AuthenticationRoutes;
